import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
export const contractManagementRouter: RouteRecordRaw[] = [
    {
        path: "/storeContract",
        name: "StoreContract",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "合同管理"
        },
        redirect: "/storeContract/index",
        children: [
            {
                path: "index",
                name: "StoreContractIndex",
                component: () => import("@/views/pages/warehouseManagement/contractManagement/index.vue"),
                meta: {
                    title: "合同管理",
                    hidden: true,
                    activeMenu: "StoreContract",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeContractDetail",
                name: "StoreContractDetail",
                component: () => import("@/views/pages/warehouseManagement/contractManagement/detail.vue"),
                meta: {
                    title: "合同详情",
                    activeMenu: "StoreContract",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "storeContractAdd",
                name: "StoreContractAdd",
                component: () => import("@/views/pages/warehouseManagement/contractManagement/form.vue"),
                meta: {
                    title: "新增合同",
                    activeMenu: "StoreContract",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeContractEdit",
                name: "StoreContractEdit",
                component: () => import("@/views/pages/warehouseManagement/contractManagement/form.vue"),
                meta: {
                    title: "修改合同",
                    activeMenu: "WarehouseManageContract",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
